import useResizeObserver from '@react-hook/resize-observer';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActionMenu, } from '../../../../action-menu';
import { Link } from '../../../../link';
import { Popover } from '../../../../popover';
import { getMeasureText } from '../../column-util/object-table-column-util';
import { TAG_HEIGHT } from '../../column-util/tag-column-util';
import styles from './tag-column.module.scss';
export const TagColumn = React.memo(({ data, colDef }) => {
    var _a, _b;
    const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'field'];
    const tagColumnProp = {
        ...fieldValues,
    };
    const contentRef = useRef(null);
    const [visibleTags, setVisibleTags] = useState([]);
    const [overflowTags, setOverflowTags] = useState([]);
    const popoverRef = React.useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const onClick = useCallback((event, tag) => {
        if (tag.onClick) {
            const menuItemEvent = {
                id: tag.id,
                label: tag.label || '',
                event,
                data,
            };
            tag.onClick(menuItemEvent);
        }
    }, [data]);
    const getOverflowTags = useCallback((tags) => {
        return [
            {
                title: '',
                items: tags.map((tag) => ({
                    ...tag,
                    onClick: (event) => {
                        setIsPopoverOpen(false);
                        onClick(event, tag);
                    },
                })),
            },
        ];
    }, [onClick]);
    const prepareTags = useCallback(() => {
        var _a, _b;
        // considering the default height of the tags column is 72 and each tag height is 30, so 2 tags can we fit.
        if (tagColumnProp.tags.length < 3) {
            setVisibleTags([...tagColumnProp.tags]);
            setOverflowTags([]);
            return;
        }
        if (contentRef) {
            const contentOffsetWidth = ((_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) - 12;
            const contentOffsetHeight = ((_b = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) - 12;
            const visibleTagsTmp = [];
            let overflowTagsTmp = [];
            const availableRows = Math.floor(contentOffsetHeight / TAG_HEIGHT);
            let occupiedRowWidth = 0;
            let currentRow = 0;
            for (let i = 0; i < tagColumnProp.tags.length; i++) {
                const tagWidth = getMeasureText(tagColumnProp.tags[i].label || '', '12px').width + 24;
                occupiedRowWidth += tagWidth;
                if (occupiedRowWidth <
                    contentOffsetWidth -
                        (currentRow + 1 === availableRows &&
                            i + 1 !== tagColumnProp.tags.length
                            ? 24
                            : 0)) {
                    visibleTagsTmp.push(tagColumnProp.tags[i]);
                    continue;
                }
                currentRow++;
                if (currentRow < availableRows) {
                    occupiedRowWidth = tagWidth;
                    visibleTagsTmp.push(tagColumnProp.tags[i]);
                    continue;
                }
                if (i < tagColumnProp.tags.length) {
                    overflowTagsTmp = [...tagColumnProp.tags.slice(i)];
                }
                break;
            }
            setVisibleTags(visibleTagsTmp);
            setOverflowTags(getOverflowTags(overflowTagsTmp));
        }
    }, [getOverflowTags, tagColumnProp.tags]);
    useEffect(() => {
        prepareTags();
    }, [prepareTags]);
    useResizeObserver(contentRef, () => {
        prepareTags();
    });
    return (React.createElement("div", { ref: contentRef, className: styles.tagColumnContainer, "data-testid": "tag-column-testid" }, tagColumnProp.tags.length > 0 && (React.createElement("div", { className: styles.tagColumnContent },
        visibleTags.map((tag) => (React.createElement("span", { className: styles.linkWrapper, key: `tag-${tag.id}` },
            React.createElement(Link, { key: `tag-${tag.id}`, color: "black", onClick: (event) => onClick(event, tag), className: styles.link }, tag.label)))),
        ((_a = overflowTags[0]) === null || _a === void 0 ? void 0 : _a.items.length) > 0 && (React.createElement(React.Fragment, null,
            React.createElement("span", { ref: popoverRef, className: styles.linkWrapper },
                React.createElement(Link, { color: "black", onClick: (_event) => setIsPopoverOpen(!isPopoverOpen), className: styles.link, "data-testid": "popover_btn" },
                    "+", (_b = overflowTags[0]) === null || _b === void 0 ? void 0 :
                    _b.items.length)),
            React.createElement(Popover, { align: "bottom-end", content: React.createElement(ActionMenu, { show: isPopoverOpen, menuItemGroups: overflowTags }), targetRef: popoverRef, isVisible: isPopoverOpen, onClickOutside: () => setIsPopoverOpen(false), enableScroll: true, "data-testid": "tags_popover" })))))));
});
//# sourceMappingURL=tag-column.js.map